module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"es":{"btnlabel":"Solicita gratis tu DEMO"},"en":{"btnlabel":"Request your free DEMO"},"pt":{"btnlabel":"Solicite sua DEMO gratuita"}}')
  delete Component.options._Ctor
}
